import { Stack } from '@mui/material';
import { type FlowHumanTaskStep } from 'flow-schema';

import { getDefaultHumanTaskFieldConfig } from './Fields/AllFields';
import { HumanTaskFieldCard } from './Fields/FieldCard';
import { HumanTaskStepFieldHeader } from './Header';
import { HumanTaskIndentContainer } from './IndentContainer';
import { useReactFlowViewContext } from '../../../../context/context';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

interface HumanTaskStepProps {
  fieldNamePrefix: string;
  stepIndex: number;
  onDelete?: () => void;
}

export function HumanTaskStep(props: HumanTaskStepProps) {
  const { fieldNamePrefix, stepIndex, onDelete } = props;
  const { value: fields = [], setValue } = useSelectedNodeField<FlowHumanTaskStep['fields']>(
    `${fieldNamePrefix}.fields`
  );
  const { isEditable } = useReactFlowViewContext();

  return (
    <Stack gap={2} aria-rowindex={stepIndex + 1} aria-roledescription="Step">
      <HumanTaskStepFieldHeader headerLabel={`Step ${stepIndex + 1}`} onDelete={onDelete} />
      <HumanTaskIndentContainer>
        <BlockValueTemplateField fieldName={`${fieldNamePrefix}.title`} label="Step Title" />
      </HumanTaskIndentContainer>
      {fields.map((field, fieldIndex) => {
        return (
          <HumanTaskFieldCard
            key={field.id}
            fieldIndex={fieldIndex}
            fieldNamePrefix={`${fieldNamePrefix}.fields.${fieldIndex}`}
            onAdd={
              isEditable
                ? () => {
                    const fieldType = fields[fieldIndex].fieldType;
                    const newFields = [...fields];
                    newFields.splice(fieldIndex + 1, 0, getDefaultHumanTaskFieldConfig(fieldType));
                    setValue(newFields);
                  }
                : undefined
            }
            onDelete={
              isEditable && fields.length > 1
                ? () => {
                    setValue(fields.filter((value) => value.id !== field.id));
                  }
                : undefined
            }
          />
        );
      })}
    </Stack>
  );
}
